import api from "./api";
import {saveAs} from 'file-saver';

export function createDataSpace(dataspaceName, metadata) {
  let endpoint = process.env.REACT_APP_DATA_MANAGER_ENDPOINT

  return api.post(endpoint + '/create/' + dataspaceName,
    metadata,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
}

export function updateMetadata(dataspaceName, metadata) {
  let endpoint = process.env.REACT_APP_DATA_MANAGER_ENDPOINT

  return api.put(endpoint + '/update/' + dataspaceName,
    metadata,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
}

export async function getAllDataSpace() {
  let endpoint = process.env.REACT_APP_DATA_MANAGER_ENDPOINT

  return api.get(endpoint + '/dataspace')
}

export async function getMetadataByDataSpace(dataspace) {
  let endpoint = process.env.REACT_APP_DATA_MANAGER_ENDPOINT

  return api.get(endpoint + '/metadata/' + dataspace)
}

export async function getDataByDataSpace(dataspace) {
  let endpoint = process.env.REACT_APP_DATA_MANAGER_ENDPOINT

  return api.get(endpoint + '/data/' + dataspace)
}

export function downloadData(fullDataPath) {
  let endpoint = process.env.REACT_APP_DATA_MANAGER_ENDPOINT

  api.get(endpoint + '/download/' + fullDataPath, {
    responseType: 'blob'
  }).then((response) => {
    saveAs(new Blob([response.data], {type: 'application/octet-stream'}), response.headers['content-disposition'])
  })
}

export async function uploadData(dataspace, file) {
  let endpoint = process.env.REACT_APP_DATA_MANAGER_ENDPOINT

  const formdata = new FormData();
  formdata.append("file", file, file.name);

  return api.post(endpoint + '/upload/' + dataspace,
    formdata
  )
}

export function createSimulator(count) {
  let endpoint = process.env.REACT_APP_DATA_MANAGER_ENDPOINT

  return api.post(endpoint + '/create/sim/' + count)
}
